// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
import Vue from 'vue'
import ElementUI from 'element-ui'
import 'element-ui/lib/theme-chalk/index.css'
import locale from 'element-ui/lib/locale/lang/el'
import App from './App'
import router from './router'
import axios from 'axios'
import store from './store'

Vue.use(ElementUI, { locale })
Vue.config.productionTip = false
Vue.config.performance = true

// function getAuthToken () {
//   // if the current store token expires soon
//   if (jwt(store.getters['auth/token']).exp - 240 <= (Date.now() / 1000).toFixed(0)) {
//     // if not already requesting a token
//     if (authTokenRequest === null) {
//       authTokenRequest = axios.post('/auth/refresh', {}, { withCredentials: true })
//         .then(response => {
//           // request complete and store
//           resetAuthTokenRequest()
//           store.commit('auth/refresh', response.data.access_token)
//           return response.data.access_token
//         })
//     }
//     return authTokenRequest
//   }
//   return store.getters['auth/token']
// }

// // tokenRequest dirty bit reseter
// function resetAuthTokenRequest() {
//   authTokenRequest = null
// }
axios.interceptors.request.use(req => {
  req.headers.common['Content-type'] = 'application/json'
  req.headers.common['Authorization'] = 'Bearer ' + sessionStorage.token
  return req
})
// // Axios Intercept Requests
// axios.interceptors.request.use(
//   async function (config) {
//   // If not one of these specific pages that doesn't need a token, use method to get the current token or request a new one.  Otherwise, use current token (possibly none)
//     if (!config.url.includes('login') && !config.url.includes('refresh') && !config.url.includes('forgot_password') && !config.url.includes('reset_password') && !config.url.includes('activate')) {
//       config.headers['Authorization'] = 'Bearer ' + await getAuthToken()
//     } else {
//       config.headers['Authorization'] = 'Bearer ' + store.getters['auth/token']
//     }
//     return config
//   },
//   function (error) {
//     return Promise.reject(error)
//   }
// )
// -- For putting the token into every header by default
// if (sessionStorage.token) {
//   axios.defaults.headers.common['Authorization'] = 'Bearer ' + sessionStorage.token
// }
// -- For intercepting every rsponse and detect 401 due to expired access token
// axios.interceptors.response.use(
//   (response) => { return response },
//   async (error) => {
//     let times = 0
//     let request = error.config
//     // we need to prevent endless redirects. Login is where you should end up after one refresh try
//     if (error.response.status === 401 && error.response.data.message.text[0] === 'Invalid Access Token' && !request._retry && times < 3) { // && error.response.data.error === 'Invalid Access Token'
//     // if (error.response.status === 401) {
//       times += 1
//       request._retry = true
//       try {
//         const response = await store.dispatch('refresh')
//         return axios(response)
//       } catch (error) {
//         // All Vuex modules must logout here
//         await store.dispatch('logout')
//         return Promise.reject(error)
//       }
//     } else {
//       alert('go to login')
//     }
//     return Promise.reject(error)
//   }
// )
Vue.filter('capitalize', function (value) {
  if (!value) return ''
  return value.toUpperCase()
})
// Vue.directive('uppercase', {
//   update (el) {
//     if (el.value) { el.value = el.value.toUpperCase() }
//   }
// })
/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  axios,
  store,
  components: { App },
  template: '<App/>'
})



// WEBPACK FOOTER //
// ./src/main.js